import React from "react";

const TrainingGallery = ({ courseDetails }) => {
  return (
    <div className="pt-md-0 pb-5">
      <div className="container">
        {courseDetails?.Gallery?.length > 0 ? (
          <h3 className=" fs_17 ff_inter fw-bold color_darkgray">
            Training Gallery
          </h3>
        ) : null}

        <div className="row mt-4">
          {courseDetails?.Gallery?.map((item, index) => {
            return (
              <div className="col-md-4 mt-3" key={index}>
                <img
                  className="w-100 h-100 object-fit-cover rounded"
                  src={item.image}
                  alt="Image"
                />
              </div>
            );
          })}
          {/* <div className="col-md-6 mt-3">
            <img className="w-100" src={gallery_image1} alt="gallery_image1" />
          </div>
          <div className="col-md-6 mt-3">
            <div className="row">
              <div className="col-6">
                <img
                  className="w-100"
                  src={gallery_image2}
                  alt="gallery_image2"
                />
              </div>
              <div className="col-6">
                <img
                  className="w-100"
                  src={gallery_image3}
                  alt="gallery_image3"
                />
              </div>
            </div>
            <div className="row mt-4">
              <div className="col-6">
                <img
                  className="w-100"
                  src={gallery_image4}
                  alt="gallery_image2"
                />
              </div>
              <div className="col-6">
                <img
                  className="w-100"
                  src={gallery_image5}
                  alt="gallery_image3"
                />
              </div>
            </div>
          </div> */}
        </div>
      </div>
    </div>
  );
};

export default TrainingGallery;
